import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import UpdateOnHoldModal from "./modal/UpdateOnHoldModal";
import moment from "moment/moment";

const QCDetails = () => {
    const privileges = secureLocalStorage.getItem("privileges");
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const initialEntries = Number(searchParams.get("entries")) || 10;
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialQueries = searchParams.get("q")?.split(",") || [];
    const initialColumns = searchParams.get("c")?.split(",") || [];

    const [entries, setEntries] = useState(initialEntries);
    const [pageIndex, setPageIndex] = useState(initialPage - 1);
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [columnFilterKey, setColumnFilterKey] = useState("");
    const [columnFilterValue, setColumnFilterValue] = useState("");

    const [currentQCReportData, setCurrentQCReportData] = useState(null);

    const { useFetch: useFetchQCBatch } = useAPIQuery({
        key: "api/check-batch",
        endpoint: "/api/check-batch/",
    });
    const {
        data: batches,
        isLoading: batchesLoading,
        isFetching: fetchingBatch,
    } = useFetchQCBatch({
        params: {
            entries: entries,
            page_no: pageIndex + 1,
            q: globalFilterValue !== "" ? globalFilterValue : columnFilterValue,
            c: globalFilterValue === "" ? columnFilterKey : "",
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const TypeMasterQuery = useAPIQuery({
        key: "api/type-master",
        endpoint: "/api/type-master/",
    });

    const TypeMasterDeliveryStatus = TypeMasterQuery.useFetch({
        params: {
            q: "QC - Results Status",
            c: "category",
        },
    });

    const viewPriviousReport = (row) => {
        console.log(row);
        const nestedItem = row?.daily_plan
            ? row?.daily_plan?.item
            : row?.po?.item;
        // depth=2 serializers return nested item objects; always pass a numeric id
        const itemId =
            typeof nestedItem === "object" && nestedItem !== null
                ? nestedItem?.id
                : nestedItem;
        const stateData = {
            item: {
                ...(typeof nestedItem === "object" && nestedItem !== null
                    ? nestedItem
                    : {}),
                id: itemId,
            },
            batch: {
                data: [
                    {
                        ...row,
                        value: row?.id,
                        label: `${row?.batch_code} - ${
                            row?.po
                                ? row?.po?.po_number
                                : row?.daily_plan
                                ? row?.daily_plan?.daily_plan_code
                                : ""
                        }`,
                    },
                ],
            },
        };

        console.log(stateData);

        navigate("/select-parameters", {
            state: { data: { ...stateData } },
        });
    };
    const viewReport = (row) => {
        const data = {
            batch: {
                ...row,
                value: row?.id,
                label: `${row?.batch_code} - ${
                    row?.po
                        ? row?.po?.po_number
                        : row?.daily_plan
                        ? row?.daily_plan?.daily_plan_code
                        : ""
                }`,
            },
        };
        console.log(data);
        navigate("/qc-report", {
            state: { data: { data } },
        });
    };

    const columns = [
        // {
        //     accessor: "batch_code",
        //     header: "Batch Code",
        //     columnWidth: 150,
        // },
        {
            accessor: "item_name",
            header: "Item Name",
            cell: (row) => (
                <div style={{ maxWidth: "170px" }}>
                    {row?.po?.item?.item_name ??
                        row?.daily_plan?.item?.item_name ??
                        "-"}
                </div>
            ),
            filterable: true,
            columnWidth: 150,
        },
        {
            accessor: "daily_plan",
            header: "Daily Plan",
            cell: (row) => <>{row?.daily_plan?.daily_plan_code ?? "-"}</>,
            filterable: true,
            columnWidth: 100,
        },
        {
            accessor: "batch",
            header: "Batch",
            cell: (row) => <>{row?.batch?.batch_number ?? "-"}</>,
            filterable: true,
            columnWidth: 100,
        },
        {
            accessor: "date",
            header: "Batch / Daily Plan Date",
            cell: (row) => {
                if (row?.batch?.created_at)
                    return moment(row?.batch?.created_at).format("LLL");
                if (row?.daily_plan?.date)
                    return moment(row?.daily_plan?.date).format("LLL");
                return "-";
            },
            columnWidth: 150,
        },
        {
            accessor: "qc_accepted_at",
            header: "QC Accepted At",
            cell: (row) => {
                if (row?.batch?.qc_accepted_at)
                    return moment(row?.batch?.qc_accepted_at).format("LLL");
                if (row?.daily_plan?.qc_accepted_at)
                    return moment(row?.daily_plan?.qc_accepted_at).format(
                        "LLL"
                    );
                return "-";
            },
            columnWidth: 150,
        },
        {
            accessor: "qc_result",
            header: "QC Result",
            cell: (row) => (
                <span
                    className={`badge badge-dot bg-${
                        row?.qc_result === 0
                            ? "danger"
                            : row?.qc_result === 1
                            ? "success"
                            : "warning"
                    }`}
                >
                    {row?.qc_result === 0
                        ? "Rejected"
                        : row?.qc_result === 1
                        ? "Accepted"
                        : "Pending"}
                </span>
            ),
            filterable: true,
            filterType: "dropdown",
            filterOpt: TypeMasterDeliveryStatus.data
                ? TypeMasterDeliveryStatus.data?.results?.data?.map((type) => ({
                      label: type?.name,
                      value: type?.value,
                  }))
                : [],
            columnWidth: 100,
        },
        {
            accessor: "system_result",
            header: "System Result",
            cell: (row) => (
                <span
                    className={`badge badge-dot bg-${
                        row?.system_result === 0
                            ? "danger"
                            : row?.system_result === 1
                            ? "success"
                            : "warning"
                    }`}
                >
                    {row?.system_result === 0
                        ? "Rejected"
                        : row?.system_result === 1
                        ? "Accepted"
                        : "Pending"}
                </span>
            ),
            filterable: true,
            filterType: "dropdown",
            filterOpt: TypeMasterDeliveryStatus.data
                ? TypeMasterDeliveryStatus.data?.results?.data?.map((type) => ({
                      label: type?.name,
                      value: type?.value,
                  }))
                : [],
            columnWidth: 100,
        },
        privileges.includes("accept_on_hold") && {
            accessor: "accept_on_hold",
            header: "Accept On Hold",
            cell: (row) => (
                <button
                    className="btn btn-secondary btn-sm"
                    data-bs-toggle="modal"
                    data-bs-target="#update-on-hold-modal"
                    onClick={() => setCurrentQCReportData(row)}
                    disabled={
                        row?.daily_plan?.on_hold_count <= 0 ||
                        row?.batch?.on_hold_count <= 0
                    }
                >
                    view
                </button>
            ),
            columnWidth: 80,
        },
        {
            accessor: "previous_report",
            header: "Previous report",
            cell: (row) => (
                <button
                    className="btn btn-secondary btn-sm"
                    onClick={() => viewPriviousReport(row)}
                >
                    view
                </button>
            ),
            columnWidth: 80,
        },
        {
            accessor: "report",
            header: "Report",
            cell: (row) => (
                <button
                    className="btn btn-primary btn-sm"
                    onClick={() => viewReport(row)}
                >
                    view
                </button>
            ),
            columnWidth: 80,
        },
    ].filter(Boolean);

    const handleGlobalFilterChange = (value) => {
        const q = value?.trim() || "";
        if (q !== "") {
            setGlobalFilterValue(q);
            setColumnFilterKey("");
            setColumnFilterValue("");
            setSearchParams((searchParams) => {
                searchParams.set("q", q);
                searchParams.delete("c");
                return searchParams;
            });
        } else if (q === "") {
            setGlobalFilterValue("");
            setSearchParams((searchParams) => {
                searchParams.delete("q");
                return searchParams;
            });
        }
    };

    const handleColumnFilterChange = (value) => {
        const q = value.map((val) => val.value?.trim() || "").join(",");
        const c = value.map((val) => val.id).join(",");
        if (q !== "" && c !== "") {
            setGlobalFilterValue("");
            setColumnFilterKey(c);
            setColumnFilterValue(q);
            setSearchParams((searchParams) => {
                searchParams.set("q", q);
                searchParams.set("c", c);
                return searchParams;
            });
        } else if (q === "" && c === "") {
            setColumnFilterKey("");
            setColumnFilterValue("");
            setSearchParams((searchParams) => {
                searchParams.delete("q");
                searchParams.delete("c");
                return searchParams;
            });
        }
    };

    const handlePagination = (value) => {
        setSearchParams((searchParams) => {
            searchParams.set("entries", value.pageSize);
            searchParams.set("page", value.pageIndex + 1);
            return searchParams;
        });
        setPageIndex(value.pageIndex);
        setEntries(value.pageSize);
    };

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content d-flex">
                        <h3 className="nk-block-title page-title">
                            QC Details
                        </h3>
                    </div>
                </div>
            </div>
            <Table
                data={batches ? batches?.results?.data : []}
                columns={columns}
                pagination
                pageIndex={pageIndex}
                pageSize={entries}
                rowCount={batches ? batches?.count : 0}
                isLoading={batchesLoading || fetchingBatch}
                globalSearch={false}
                editRows={false}
                deleteRows={false}
                filterModal={false}
                selectRows={false}
                defaultGlobalSearchValue={
                    initialQueries.length > 0 && initialColumns.length <= 0
                        ? initialQueries[0]
                        : undefined
                }
                defaultColumnFiltersValue={
                    initialQueries.length > 0 && initialColumns.length > 0
                        ? initialColumns.map((column, index) => ({
                              id: column,
                              value: initialQueries?.[index] ?? "",
                          }))
                        : undefined
                }
                onGlobalFilterChange={handleGlobalFilterChange}
                onColumnFilterChange={handleColumnFilterChange}
                onPaginationChange={handlePagination}
            />
            <UpdateOnHoldModal currentQCReportData={currentQCReportData} />
        </>
    );
};

export default QCDetails;
